const LocationOn = () => {
    return <svg xmlns='http://www.w3.org/2000/svg' width='11.5' height='15' viewBox='0 0 11.5 15'>
        <path id='Icon_material-location-on' data-name='Icon material-location-on' d='M12.75,3A5.246,5.246,0,0,0,7.5,8.25c0,3.938,3.729,8.75,5.25,8.75S18,12.188,18,8.25A5.246,5.246,0,0,0,12.75,3Zm0,7.125A1.875,1.875,0,1,1,14.625,8.25,1.876,1.876,0,0,1,12.75,10.125Z' transform='translate(-7 -2.5)' fill='none' stroke='#404040' strokeWidth='1' />
    </svg>
}

export default LocationOn